// The admin talks to the BFF and nothing else: accounts (the shared core's
// /login) and every /admin/* call, which the BFF forwards to the backend.
export const BFF_BASE_URL =
    process.env.REACT_APP_BFF_BASE_URL || 'http://localhost:8002';
